export const heroImage =
  "https://images.pexels.com/photos/7693729/pexels-photo-7693729.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=1400&w=2200";

export const countryOptions = [
  { code: "+20", en: "Egypt", ar: "مصر" },
  { code: "+966", en: "Saudi Arabia", ar: "السعودية" },
  { code: "+971", en: "UAE", ar: "الامارات" },
  { code: "+965", en: "Kuwait", ar: "الكويت" },
  { code: "+973", en: "Bahrain", ar: "البحرين" },
  { code: "+974", en: "Qatar", ar: "قطر" },
  { code: "+1", en: "United States", ar: "الولايات المتحدة" },
  { code: "+44", en: "United Kingdom", ar: "المملكة المتحدة" },
] as const;

export function fileRequiredTest(value: unknown) {
  return value instanceof FileList && value.length > 0;
}